import i18n from '../resources/index'

export const objectList = [
  {
    id: 'car',
    name: i18n.t('realtime.car'),
  },
  {
    id: 'people',
    name: i18n.t('realtime.people'),
  },
  {
    id: 'assets',
    name: i18n.t('realtime.assets'),
  },
  {
    id: 'pet',
    name: i18n.t('realtime.pet'),
  },
]
export const colorsList = [
  {
    id: 1,
    color: '#9C27B0',
    name: i18n.t('realtime.purple'),
  },
  {
    id: 2,
    color: '#1F8CE3',
    name: i18n.t('realtime.blue'),
  },
  {
    id: 3,
    color: '#4CAF50',
    name: i18n.t('realtime.green'),
  },
  // {
  // 	id: "yellow",
  // 	name: "黄"
  // },
  {
    id: 4,
    color: '#F44336',
    name: i18n.t('realtime.red'),
  },
  {
    id: 5,
    color: '#FF9800',
    name: i18n.t('realtime.orange'),
  },
]
export const ObjectIconList = [
  {
    id: 1,
    icon: 'car',
  },
  {
    id: 2,
    icon: 'businesscar',
  },
  {
    id: 3,
    icon: 'bus',
  },
  {
    id: 4,
    icon: 'bicycle',
  },
  {
    id: 5,
    icon: 'excavator',
  },
  {
    id: 6,
    icon: 'excavator2',
  },
  {
    id: 7,
    icon: 'plain',
  },
  {
    id: 8,
    icon: 'ship',
  },
  {
    id: 9,
    icon: 'suv',
  },
  {
    id: 10,
    icon: 'transportmixer',
  },
  {
    id: 11,
    icon: 'truck',
  },
  {
    id: 12,
    icon: 'van',
  },

  // {
  //     id: 13,
  //     icon: 'arrow'
  // }
]
export const deviceTypeList = [
  {
    code: 0x0001,
    name: 'MT90EN',
  },
  {
    code: 0x0002,
    name: 'MT90CH',
  },
  {
    code: 0x0003,
    name: 'T1',
  },
  {
    code: 0x000a,
    name: 'MVT600',
  },
  {
    code: 0x000b,
    name: 'MVT100',
  },
  {
    code: 0x0019,
    name: 'TC68CN',
  },
  {
    code: 0x001a,
    name: 'TC68EN',
  },
  {
    code: 0x001c,
    name: 'T311',
  },
  {
    code: 0x001d,
    name: 'T322',
  },
  {
    code: 0x001e,
    name: 'TC68SEN',
  },
  {
    code: 0x001f,
    name: 'TC68SCN',
  },
]

// MDVR设备类型
export const mdvrTypeList = [
  'MD511H',
  'MD522S',
  'MD811H',
  'MD822S',
  'MD533S',
  'MD500S',
  'MD600',
  'MD833H',
  'MD101',
  'MD201',
  'MD300',
  'MD999',
  'MD300A',
]

// 支持对讲设备类型
export const intercomList = [
  'MD511H',
  'MD522S',
  'MD811H',
  'MD822S',
  'MD533S',
  'MD500S',
  'MD600',
  'MD833H',
  'MD101',
  'MD201',
  'MD300',
  'MD999',
  'MD300A',
]

// 不支持OTA进度条设备类型
export const mdvrNoProgressList = ['MD511H', 'MD522S', 'MD811H', 'MD822S', 'MD533S', 'MD101']

// ACC状态bit位判断设备类型
export const bit8TrackerList = ['TA255L', 'TA255E', 'T711L', 'T799L']
export const bit9TrackerList = [
  'MVT100',
  'MVT340',
  'MVT380',
  'MVT800',
  'T322',
  'MD511H',
  'MD522S',
  'MD811H',
  'MD822S',
  'MD500S',
  'MD533S',
  'MD833H',
  'MD600',
  'T366G',
  'T366L',
  'T399G',
  'T399L',
  'T399E',
  'T366',
  'MD101',
  'MD300',
  'MD999',
  'MD300A',
]
export const bit10TrackerList = [
  'MVT600',
  'T1',
  'T333',
  'T633L',
  'T633L-FW',
  'T333L',
  'T622E_F9',
  'T622G_F9',
]

// 不支持ACC状态设备类型
export const noAccTrackerList = ['MT90', 'K211L', 'K211E', 'P99L', 'P88L']

// 铱星设备类型
export const iridiumTrackerList = ['T633Li', 'T622G_F9', 'T622E_F9']
